<template>
  <div id="Expert">
    <Head />
    <div class="hotspot clear">
      <Nav ms="/Expert" />
      <div class="H-right">
        <div class="title1">组织评审管理</div>
        <div class="switch">
          <p>专家评审修改</p>
          <el-switch v-model="val" @change="changeStatus"></el-switch>
          <span :style="val ? 'color:#409eff' : 'color:#303133'">{{
            val ? "开启" : "关闭"
          }}</span>
          <span>评审时间：</span>
          <el-date-picker
            v-model="time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <el-button
            @click="submitTime"
            type="primary"
            style="margin-left: .1rem;"
            >确定修改</el-button
          >
        </div>
        <div class="box" style="margin-bottom: .1rem;">
          <span style="color:red"
            >备注：评审时间设定作为用户报告状态显示依据。当前时间超过评审开始时间，个人成果状态从
            “中国煤炭工业协会待审核” 显示为中国煤炭工业协会正在评审”。
            当前时间超过评审结束时间，个人成果状态显示为“中国煤炭工业协会评审结束。
          </span>
        </div>
        <div class="H-header" v-if="switchover.head">
          <div class="t-left">
            <input type="text" placeholder="请输入姓名查询" v-model="selname" />

            <!-- <select v-model="selstatus" @change="getSelstatus">
              <option value="1">可用</option>
              <option value="2">禁用</option>
            </select>-->
            <!-- <div class="btn btnmini" @click="getinfo('1')">查询</div> -->
          </div>
          <div class="btns">
            <div
              class="btn btnmini"
              style="background:#f76423"
              @click="getSpecialist"
            >
              编辑组
            </div>
            <div
              class="btn btnmini"
              style="background:#67C23A"
              @click="getReviewstandard()"
            >
              修改标准
            </div>
            <div class="btn btnmini" @click="Popups('1')">新增专家</div>
          </div>
        </div>
        <div class="H-header" v-else>
          <div class="btns" style="width:100%">
            <div
              class="btn btnmini"
              @click="
                switchover.head = true;
                switchover.main = true;
              "
            >
              返回
            </div>
            <div class="btn btnmini" @click="dialogTableVisible = true">
              新增组
            </div>
          </div>
        </div>

        <div class="t_main" v-if="switchover.main">
          <el-table
            border
            :header-cell-style="{
              'background-color': '#28313F',
              color: '#fff',
              height: '0.5rem',
            }"
            :stripe="true"
            :data="
              tableData.filter(
                (data) =>
                  !selname ||
                  data.Realname.toLowerCase().includes(selname.toLowerCase())
              )
            "
            style="width: 100%;max-height:95%"
            :row-style="{ height: '0.4rem' }"
          >
            <el-table-column
              width="50"
              label="序号"
              header-align="center"
              align="center"
              type="index"
            ></el-table-column>
            <el-table-column
              prop="Realname"
              min-width="8"
              label="姓名"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Position"
              min-width="8"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              min-width="13"
              label="手机号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="workunit"
              min-width="13"
              label="工作单位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              min-width="15"
              label="专业方向"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.ParentclassificationName }}</p>
                <p>{{ scope.row.classificationName }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="ExpertGroup"
              label="所在专家组"
              min-width="23"
              header-align="center"
            >
              <template slot-scope="scope">
                <ul>
                  <li
                    v-for="(item1, index) in scope.row.ExpertGroup[0]"
                    :key="index"
                  >
                    {{ item1.GroupName }}
                  </li>
                </ul>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="12"
              header-align="center"
              align="center"
            >
              <!-- <template slot-scope="scope">
                <el-button
                  size="mini"
                  style="background: #2D65D2;color:#ffffff;"
                  @click="Popups('1',scope.row)"
                >修改</el-button>
                <el-button
                  size="mini"
                  style="background: #F3252F;color:#ffffff;margin-left:0"
                  @click="Del(scope.row)"
                >删除</el-button>
              </template>-->
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="medium"
                  @click="Popups('1', scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right;height: 0.45rem;"
            v-if="tableData.length > 0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
        <div class="t_main" v-else>
          <div v-if="list.length > 0">
            <el-card
              class="checkbox-table"
              v-for="(item, indexkey) in list"
              :key="item.id"
            >
              <!-- <template> -->
              <!-- <el-checkbox
                class="check1"
                style="font-weight: 600;margin-bottom: .17rem "
                v-model="menusIds"
                :label="item.id"
                @change="handleCheck(1,indexkey)"
              >-->
              <div class="checkbox-table_title">
                <div
                  style="font-size:.2rem;color:#333;"
                  v-show="inputs[indexkey]"
                  @click="asd(indexkey)"
                >
                  {{ item.title }}
                </div>
                <el-input
                  type="text"
                  :style="{ width: parseInt(item.title.length) / 3.5 + 'rem' }"
                  v-show="!inputs[indexkey]"
                  v-model="item.title"
                  @blur="setTitle(item, indexkey)"
                />
              </div>

              <!-- </el-checkbox> -->
              <div class="table" v-if="item.info[0].ID">
                <div
                  v-for="item1 in item.info"
                  class="line-check"
                  :key="item1.ID"
                  style
                >
                  <!-- <el-checkbox
                    class="check2"
                    @change="handleCheck(2,indexkey)"
                    v-model="menusIds"
                    :label="item1.ID"
                  >-->
                  <el-checkbox
                    class="check2"
                    v-model="menusIds"
                    :label="item1.ID"
                  >
                    <span
                      style="font-size:.18rem;display:block;margin-bottom:.07rem;color:#000"
                      >{{ item1.name }}</span
                    >
                    <span style="font-size:.16rem;display:block">{{
                      item1.major1
                    }}</span>
                    <span style="font-size:.16rem;">{{ item1.major2 }}</span>
                  </el-checkbox>
                </div>
              </div>
              <p class="table" v-else>暂无组成员信息,请添加组成员</p>
              <!-- </template> -->
              <div class="operation">
                <div class="btn add" @click="addUser(item)">新增成员</div>
                <div
                  class="btn del"
                  v-if="item.info[0].ID"
                  @click="delUser(item)"
                >
                  删除成员
                </div>
                <div class="btn delG" @click="delGroup(item)">删除组</div>
              </div>
            </el-card>
          </div>
          <p v-else class="show">暂无组信息,请添加组</p>
        </div>
        <el-dialog
          :visible.sync="isPopup"
          width="900px"
          center
          :title="status ? '修改专家' : '新增专家'"
        >
          <!-- <div class="Popup" v-show="isPopup"> -->
          <div class="none" @click="Popups(0)"></div>
          <div v-if="isPopup" class="a_forms">
            <!-- <div class="f-top">
              <div @click="Popups(0)"></div>
              {{ status ? '修改' : '新增' }}专家
            </div> -->
            <div class="f-info">
              <div class="f-info-left">
                <img
                  :src="
                    form.Image
                      ? form.Image
                      : require('../../assets/back/zhuanjiatouxiang.png')
                  "
                  alt
                />
                <div class="up" @click="uploadImg"><i></i>上传头像</div>
                <div
                  class="btn"
                  style="width:100%;height:.4rem;line-height:.4rem"
                  v-if="status"
                  @click="setInfo"
                >
                  确认修改
                </div>
                <div
                  class="btn"
                  style="width:100%;height:.4rem;line-height:.4rem;background:rgb(251, 23, 82);margin-top:.1rem"
                  @click="Del(form)"
                  v-if="status"
                >
                  删除用户
                </div>
                <div
                  class="btn"
                  style="width:100%;height:.4rem;line-height:.4rem"
                  @click="addinfo"
                  v-else
                >
                  确认新增
                </div>
              </div>
              <div class="f-title">
                <div class="f-left">
                  <div>
                    <span>姓名</span>
                    <!-- <a>:</a> -->
                    <input
                      type="text"
                      placeholder="请输入专家姓名"
                      v-model="form.Realname"
                    />
                    <!-- <i>*</i> -->
                  </div>
                  <div>
                    <span>学历</span>
                    <!-- <a>:</a> -->
                    <input
                      type="text"
                      placeholder="请填写学历"
                      v-model="form.education"
                    />
                    <!-- <i>*</i> -->
                  </div>
                  <div>
                    <span>工作单位</span>
                    <!-- <a>:</a> -->
                    <input
                      type="text"
                      placeholder="请填写工作单位"
                      v-model="form.workunit"
                    />
                    <!-- <i>*</i> -->
                  </div>
                  <div>
                    <span>电子邮箱</span>
                    <!-- <a>:</a> -->
                    <input
                      type="text"
                      placeholder="请填写电子邮箱"
                      v-model="form.Email"
                    />
                    <!-- <i>*</i> -->
                  </div>
                  <!-- <div>
                    <span>方向划分</span>
                    <a>:</a>
                    <input type="text" v-model="form.Classname" placeholder="请选择" />
                    <el-cascader
                      style="width: 30%;height: 0.3rem;position:absolute;left: 1rem;opacity: 0;overflow:hidden;"
                      :options="options"
                      :props="{ expandTrigger: 'hover' }"
                      @change="handleChange"
                    ></el-cascader>
                    <i>*</i>
                  </div>-->
                  <div>
                    <span>密码</span>
                    <!-- <a>:</a> -->
                    <input
                      type="password"
                      placeholder="请输入密码"
                      v-model="form.Pwd"
                    />
                    <!-- <i>*</i> -->
                  </div>
                  <div>
                    <span style>专业方向</span>
                    <!-- <a>:</a> -->
                    <!-- <input
                      type="text"
                      v-if="!form.classificationName"
                      v-model="form.Classname"
                      placeholder="请选择专业方向"
                    />-->
                    <input
                      type="text"
                      v-model="form.Classname"
                      placeholder="请选择专业方向"
                    />
                    <!-- <input type="text" v-else v-model="form.classificationName" /> -->
                    <el-cascader
                      style="margin-left:.2rem;width: 60%;height: 0.3rem;position:absolute;left: 1rem;opacity: 0;overflow:hidden;"
                      :options="options"
                      :props="{ expandTrigger: 'hover' }"
                      @change="handleChange"
                    ></el-cascader>
                    <!-- <i>*</i> -->
                  </div>
                </div>
                <div class="f-left f-right">
                  <div style="  display: flex;">
                    <span>出生年月</span>
                    <!-- <a>:</a> -->
                    <input type="text" v-model="form.birthdate" />
                    <div class="block">
                      <el-date-picker
                        style="margin-left:.2rem; width:2.05rem;heigth:.3rem;position:absolute;left: 1rem;opacity: 0;overflow:hidden;"
                        v-model="form.birthdate"
                        type="month"
                        placeholder="选择年月"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                      ></el-date-picker>
                    </div>
                    <!-- <i>*</i> -->
                  </div>
                  <div>
                    <span>职称</span>
                    <input
                      type="text"
                      v-model="form.Position"
                      placeholder="请填写职称"
                    />
                  </div>
                  <div>
                    <span>职务</span>
                    <input
                      type="text"
                      v-model="form.jobcontent"
                      placeholder="请填写职务"
                    />
                  </div>
                  <div>
                    <span>手机号</span>
                    <input
                      type="text"
                      v-model="form.Phone"
                      placeholder="请输入手机号"
                    />
                  </div>
                  <div>
                    <span>确认密码</span>
                    <input
                      type="password"
                      v-model="form.Pwd1"
                      placeholder="请确认密码"
                    />
                  </div>
                  <div>
                    <span>专家组</span>
                    <el-select
                      style="width:60%;margin-left:.2rem"
                      v-model="value1"
                      multiple
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in panel"
                        :key="item.GroupID"
                        :label="item.GroupName"
                        :value="item.GroupID"
                      ></el-option>
                    </el-select>

                    <!-- <el-transfer v-model="value" :data="data"></el-transfer> -->
                  </div>
                  <!-- <div>
                    <span>专家简介</span>
                    <a>:</a>
                    <textarea
                      name
                      id
                      cols="30"
                      rows="10"
                      v-model="form.introduction"
                      placeholder="请输入专家介绍"
                    ></textarea>
                    <i>*</i>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="f-bottom">
              <span>专家简介</span>
              <textarea
                name
                id
                cols="30"
                rows="10"
                v-model="form.introduction"
                placeholder="请输入专家介绍"
              ></textarea>
            </div>
          </div>
        </el-dialog>
        <!-- </div> -->
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="80%" center>
      <div slot="title" style="font-size:.22rem">创新成果评审标准修改</div>
      <div style="float:right;margin:0 .2rem .1rem 0">
        <el-button type="primary" size="medium" @click="addreviewstandard()"
          >新增标准</el-button
        >
      </div>
      <el-table
        border
        :data="tableData1"
        :stripe="true"
        :header-cell-style="tableBG"
        :row-style="{ height: '0.4rem' }"
        highlight-current-row
        @cell-click="cellClick"
      >
        <el-table-column
          prop="No"
          label="序号"
          header-align="center"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.No"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.No }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Title"
          label="评审内容"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.Title"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.Title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Score"
          label="分值"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.Score"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.Score }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="FirstLevel"
          label="一等"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.FirstLevel"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.FirstLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="SecondLevel"
          label="二等"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.SecondLevel"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.SecondLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ThirdLevel"
          label="三等"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.ThirdLevel"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.ThirdLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="PassLevel"
          label="淘汰类"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <textarea
              v-model="scope.row.PassLevel"
              v-if="scope.row.seen"
              @blur="loseFcous(scope.$index, scope.row)"
            ></textarea>
            <span v-else>{{ scope.row.PassLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="addReviewstandard(scope.row)"
              >保存</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="delReviewstandard(scope.row.ID)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-upload
      ref="uploads"
      id="upload1"
      style="opacity:0;height:0;overflow:hidden;"
      class="avatar-uploader1"
      :http-request="upload"
      :auto-upload="false"
      action="upload1"
      :on-success="handleSuccess"
      :on-change="submitUpload"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      accept=".jpeg, .jpg, .png"
    >
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-dialog
      title="新增组"
      width="35%"
      top="30vh"
      :visible.sync="dialogTableVisible"
    >
      <el-form>
        <el-form-item label="组名">
          <el-input
            style="width:80%"
            v-model="GroupName"
            type="text"
            placeholder="请输入专家组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGroupName()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增成员"
      center
      width="12rem"
      :visible.sync="dialogTableVisible1"
      :before-close="reset"
    >
      <el-input
        v-model="selname"
        @input="searchUser"
        style="width:180px;margin-bottom:10px"
        placeholder="输入名字或手机号"
      ></el-input>
      <el-table
        border
        :header-cell-style="{
          'background-color': '#28313F',
          color: '#fff',
          height: '0.5rem',
        }"
        :stripe="true"
        :data="tableData2"
        style="width: 100%"
        height="500"
        tooltip-effect="dark"
        :row-key="rowKey"
        @selection-change="handleSelectionChange"
        :row-style="{ height: '0.3rem' }"
      >
        <el-table-column
          type="selection"
          width="40px"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          prop="Realname"
          min-width="8"
          label="姓名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Position"
          min-width="8"
          label="职称"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Phone"
          min-width="12"
          label="手机号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="workunit"
          min-width="20"
          label="工作单位"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="18"
          label="专业方向"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.ParentclassificationName }}</p>
            <p>{{ scope.row.classificationName }}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column >

        </el-table-column>-->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogTableVisible1 = false;
            selname = '';
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="addGroup">确 定</el-button>
      </div>
    </el-dialog>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  name: "Expert",
  data() {
    return {
      val: "",
      total: 0,
      tableData: [],
      Page1: 1,
      value: 1,
      PageSize1: 30,
      isPopup: false,
      options: "",
      status: "", // 1修改 0删除
      cascadervalue: "",
      selname: "",
      selstatus: 1,
      form: {
        Realname: "", //专家姓名
        Pwd: "",
        Pwd1: "",
        birthdate: "", //出生年月
        education: "", //学历
        workunit: "", //工作单位
        jobcontent: "",
        Type: 2,
        Status: 1,
        Phone: "",
        introduction: "", //专家简介
        Classname: "",
        classification: "",
        Image:
          "http://39.100.116.249:92/upload/image/202005/20200511134033845.png",
        Company: "",
      },
      fromback: {
        Realname: "", //专家姓名
        Pwd: "",
        Pwd1: "",
        birthdate: "", //出生年月
        education: "", //学历
        workunit: "", //工作单位
        jobcontent: "",
        Type: 2,
        Status: 1,
        Phone: "",
        introduction: "", //专家简介
        Classname: "",
        classification: "",
        Image:
          "http://39.100.116.249:92/upload/image/202005/20200511134033845.png",
        Company: "",
      },
      tableData2: [],
      // fromback: {
      //   Realname: "",
      //   Pwd: "",
      //   Pwd1: "",
      //   Type: 2,
      //   Phone: "",
      //   Status: 1,
      //   introduction: "",
      //   Classname: "",
      //   classification: "",
      //   group: "",
      //   Company: ""
      // },
      centerDialogVisible: false,
      showEdit: [],
      showBtn: [],
      showBtnOrdinary: true,
      tableData1: [],
      switchover: {
        head: true,
        main: true,
      },
      isIndeterminate: true,
      checkAll: false,
      menusIds: [],
      list: [],
      HeaderImg: "",
      value2: "",

      dialogTableVisible: false,
      dialogTableVisible1: false,
      GroupName: "", //专家组名称
      panel: [], //专家组
      value1: [], //专家新增选择专家组
      inputs: [], //控制输入框,
      multipleSelection: "",
      group: [],
      // value:[],
      // data:generateData(),
      time: "", // 评审结束时间
      userName: "",
    };
  },
  created() {
    this.getOptions();
    this.getinfo();
    this.tableData1.forEach((val) => {
      val.seen = false;
    });
    this.getSwitch();
  },
  methods: {
    getSwitch() {
      this.$axios
        .post("log/systemReview?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            this.val = res.data.data.nums == 0 ? true : false;
            // var newDate1 = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.data.data.reviewStart)
            // var newDate2 = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.data.data.reviewEnd)
            this.time = [res.data.data.reviewStart, res.data.data.reviewEnd];
          }
        });
    },
    changeStatus(val) {
      this.$axios
        .post(
          "log/systemReview_edit",
          this.$qs.stringify({
            status: val ? "0" : "1",
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.val = !this.val;
            this.$message.error(res.data.msg);
          }
        });
    },
    addGroup() {
      let that = this;
      this.$confirm("是否分配到该组?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var str = "";
          this.multipleSelection.map((val) => {
            str += val.ID + ",";
          });
          // console.log(this.group.info[0])
          if (this.group.info[0].ID) {
            this.group.info.map((val) => {
              str += val.id + ",";
            });
          }

          let UserIDS = str.substr(0, str.length - 1);
          console.log(UserIDS);
          if (UserIDS) {
            that.$axios
              .post(
                "expertgrouprelations/save",
                that.$qs.stringify({
                  token: sessionStorage.getItem("token"),
                  UserIDS: UserIDS,
                  GroupIDS: that.group.id,
                })
              )
              .then((res) => {
                if (res.data.code == 10000) {
                  that.dialogTableVisible1 = false;
                  that.multipleSelection = "";
                  that.$message({
                    type: "success",
                    message: "添加成功!",
                  });
                  that.getSpecialist();
                } else {
                  that.$message({
                    type: "warning",
                    message: res.data.msg,
                  });
                }
              });
            // console.log(3123131);
          } else {
            this.dialogTableVisible1 = false;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    asd(i) {
      this.inputs[i] = !this.inputs[i];
      this.$set(this.inputs, i, this.inputs[i]);
    },
    getUser(item) {
      let that = this;
      this.$axios
        .post(
          "user/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            realname: this.selname,
            status: 1,
            Type: 2,
            num: 999,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.tableData2 = res.data.data.list;
            var arr = [];
            item.info.map((val) => {
              arr.push(val.id);
            });
            this.tableData2 = this.tableData2.filter(function(item) {
              return arr.indexOf(item.ID) == -1;
            });
            console.log(this.tableData2);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    searchUser() {
      this.getUser(this.group);
    },
    addUser(item) {
      this.dialogTableVisible1 = true;
      this.group = item;
      this.getUser(item);
    },
    reset() {
      this.selname = "";
      this.dialogTableVisible1 = false;
    },
    handleSelectionChange(val) {
      // if (this.multipleSelection && this.multipleSelection.length > 0) {
      //   this.multipleSelection.push(val);
      // } else {
      //   }
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    rowKey(row) {
      //row-key就是要指定一个key标识这一行的数据,保证唯一即可
      return row.ID;
    },
    delUserfn(item) {
      let that = this;
      var GroupID = "";
      item.info.map((val) => {
        that.menusIds.map((val1) => {
          if (val.ID == val1) {
            GroupID += val.id + ",";
          }
        });
      });
      GroupID = GroupID.substr(0, GroupID.length - 1);
      that.$axios
        .post(
          "expertgrouprelations/del",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            GroupID: item.id,
            UserIDS: GroupID,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            that.$message({
              type: "success",
              message: "删除成功!",
            });
            that.getSpecialist();
          } else {
            that.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    delGroup(item) {
      let that = this;
      console.log(item);
      that
        .$confirm("确认删除该组?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .post(
              "expertgroup/del",
              that.$qs.stringify({
                token: sessionStorage.getItem("token"),
                GroupID: item.id,
              })
            )
            .then((res) => {
              if (res.data.code == 10000) {
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
                that.getSpecialist();
              } else {
                that.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delUser(item) {
      let that = this;
      console.log(item);
      // console.log(this.menusIds)
      if (this.menusIds.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择删除的成员",
        });

        return;
      }
      that
        .$confirm("确认从该组删除成员?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          // console.log(111111)
          that.delUserfn(item);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

      // console.log(item,GroupID);
    },
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    addOBj(key, val) {
      var obj = {};
      var data = Object.assign(obj, this.toObj2(key, val));
      return data;
    },
    getSpecialist() {
      this.switchover.head = false;
      this.switchover.main = false;
      let that = this;
      this.$axios
        .post(
          "expertgrouprelations/index?token=" + sessionStorage.getItem("token")
        )
        .then((res) => {
          console.log(res.data.data.list);
          if (res.data.code == 10000) {
            this.list = [];
            for (var key in res.data.data.list) {
              this.list.push(res.data.data.list[key]);
            }
            // console.log(this.list);
            var a = [];

            this.list.map((val, index) => {
              console.log(val);
              that.inputs[index] = true;
              var info = [];
              a.push(
                Object.assign(
                  that.toObj2("title", val[0].GroupName),
                  that.toObj2("id", val[0].GroupID)
                )
              );
              val.map((val1) => {
                info.push(
                  Object.assign(
                    Object.assign(
                      Object.assign(
                        that.toObj2("name", val1.Realname),
                        that.toObj2("id", val1.UserID)
                      ),
                      Object.assign(
                        that.toObj2("major1", val1.ParentClassName),
                        that.toObj2("major2", val1.ClassName)
                      )
                    ),
                    that.toObj2("ID", val1.ID)
                  )
                );
                // console.log(info)
                a[index].info = info;
              });
            });
            console.log(a);
            this.list = a;
            // this.list = res.data.data.list;
            // this.list.forEach((val, index) => {
            //   this.list[index].GroupName = val[0].GroupName;
            //   this.list[index].id = val[0].GroupID;
            //   this.inputs[index] = true;
            // });
          }
          console.log(that.inputs);
          console.log(this.list);
        });
    },
    setTitle(item, i) {
      let that = this;
      this.$axios
        .post(
          "expertgroup/update",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            GroupID: item.id,
            GroupName: item.title,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            that.$message({
              type: "success",
              message: "修改成功",
            });
            that.getSpecialist();
          } else {
            that.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
      this.inputs[i] = true;
    },
    addGroupName() {
      let that = this;
      this.$axios
        .post(
          "expertgroup/add",
          this.$qs.stringify({
            token: sessionStorage.getItem("token"),
            GroupName: this.GroupName,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            that.getSpecialist();
            this.GroupName = "";
            that.dialogTableVisible = false;
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传

    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      return true;
    },
    upload(file) {
      let that = this;
      console.log(file);
      var formData = new FormData();
      console.log(file.file);
      formData.append("file", file.file);
      formData.append("upload_type", "image");
      console.log(formData);
      this.loading = true;
      that.$axios
        .post("upload/index?", formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            // this.loading = false;
            this.HeaderImg = res.data.data;
            this.form.Image = res.data.data;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message(res.data.msg);
          }
        });
      this.$refs.uploads.clearFiles();
    },
    uploadImg() {
      console.log(1);
      document.querySelector(".avatar-uploader1 input").click();
    },
    test1() {
      console.log(this.menusIds);
    },
    // 处理选择事件
    handleCheck(type, a = 0) {
      // 多选框
      console.log(type, a);
      let self = this;
      if (type == 2) {
        // 二级菜单点击
        let index = 0;
        self.list[a].info.map((item) => {
          if (self.menusIds.indexOf(item.id) > -1) {
            index += 1;
          }
        });
        if (index > 0) {
          if (self.menusIds.indexOf(self.list[a].id) < 0) {
            self.menusIds.push(self.list[a].id);
          }
        } else {
          if (self.menusIds.indexOf(self.list[a].id) > 0) {
            self.menusIds.splice(self.menusIds.indexOf(self.list[a].id), 1);
          }
        }
      } else {
        if (self.menusIds.indexOf(self.list[a].id) > -1) {
          self.list[a].info.map((item) => {
            if (self.menusIds.findIndex((n) => n == item.id) < 0) {
              self.menusIds.push(item.id);
            }
          });
        } else {
          self.list[a].info.map((item) => {
            if (self.menusIds.findIndex((n) => n == item.id) > -1) {
              self.menusIds.splice(
                self.menusIds.findIndex((n) => n == item.id),
                1
              );
            }
          });
        }
      }
    },
    loseFcous(index, row) {
      // debugger;
      row.seen = false;
    },
    delReviewstandard(id) {
      let that = this;
      that
        .$confirm("确认从该组删除成员?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          // console.log(111111)
          this.$axios
            .post(
              "reviewstandard/del?token=" +
                sessionStorage.getItem("token") +
                "&ID=" +
                id
            )
            .then((res) => {
              if (res.data.code == 10000) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.getReviewstandard();
                // console.log(res.data.data);
                // this.tableData1 = res.data.data;
                // this.centerDialogVisible = true;
              } else {
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addreviewstandard() {
      var obj = {};
      obj = { ...this.tableData1[0] };
      for (var key in obj) {
        obj[key] = "";
      }
      this.tableData1.push(obj);
    },
    cellClick(row) {
      // debugger;
      row.seen = true;
    },
    getReviewstandard() {
      this.$axios
        .post("reviewstandard/index?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.tableData1 = res.data.data;
            this.centerDialogVisible = true;
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    addReviewstandard(row) {
      let that = this;
      this.$confirm("是否修改评分标准?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.ID) {
            that.$axios
              .post(
                "reviewstandard/update?token=" +
                  sessionStorage.getItem("token"),
                that.$qs.stringify(row)
              )
              .then((res) => {
                if (res.data.code == 10000) {
                  this.$message({
                    type: "success",
                    message: res.data.msg,
                  });
                  that.getReviewstandard();
                } else {
                  this.$message({
                    type: "wargning",
                    message: res.data.msg,
                  });
                }
              });
          } else {
            that.$axios
              .post(
                "reviewstandard/add?token=" + sessionStorage.getItem("token"),
                that.$qs.stringify(row)
              )
              .then((res) => {
                if (res.data.code == 10000) {
                  this.$message({
                    type: "success",
                    message: res.data.msg,
                  });
                  that.getReviewstandard();
                } else {
                  this.$message({
                    type: "wargning",
                    message: res.data.msg,
                  });
                }
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    tableBG(row) {
      if (row) {
        if (row.columnIndex == 3) {
          return "background:#06a814;color:#fff";
        }
        if (row.columnIndex == 4) {
          return "background:#08599a;color:#fff";
        }
        if (row.columnIndex == 5) {
          return "background:#be3d1d;color:#fff";
        }
        if (row.columnIndex == 6) {
          return "background:#de0637;color:#fff";
        }
        return "background:#001743;color:#fff";
      }
    },
    handleChange(a) {
      console.log(a);
      this.form.classification = a[1];
      // this.form.majors=
      this.getvalue(a);
    },
    getSelstatus() {
      this.getinfo();
    },
    Popups(a, b) {
      if (a) {
        if (b) {
          this.form = b;
          console.log(this.form);
          this.status = 1;
          this.form.ExpertGroup[0] &&
            this.form.ExpertGroup[0].map((val) => {
              // console.log(val)
              this.value1.push(val.GroupID);
            });
          this.form.Classname =
            this.form.ParentclassificationName +
            "——" +
            this.form.classificationName;
          this.$axios
            .post("expertgroup/index?token=" + sessionStorage.getItem("token"))
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                this.panel = res.data.data.list;
                console.log(this.panel);
              } else {
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            });
        } else {
          this.status = 0;
          // this.form .forEach(val=>{
          //   if(val.Type)
          // })
          this.form = this.fromback;
          this.value1 = [];
          // for (var key in this.form) {
          //   if (key != "Type" && key != "Status") {
          //     this.form[key] = "";
          //   }
          // }
          console.log(this.form);
          this.$axios
            .post("expertgroup/index?token=" + sessionStorage.getItem("token"))
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                this.panel = res.data.data.list;
              } else {
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            });
        }
        this.isPopup = true;
      } else {
        this.value1 = [];
        //  for (var key1 in this.form) {
        //   if (key1 != "Type" && key1 != "Status") {
        //     this.form[key1] = "";
        //   }
        // }
        // this.form=this.fromback

        this.isPopup = false;
      }
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      //this.GetClass()
      this.getinfo();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      //this.GetClass()
      this.getinfo();
    },
    getvalue(a) {
      if (!a) {
        return;
      }
      var that = this;
      that.$axios
        .post(
          "classification/info?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({ ID: a[1] })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            let superclass = "";
            if (res.data.data.info) {
              res.data.data.top_menu.forEach((val) => {
                if (val.ID == a[0]) {
                  superclass = val.Classname;
                }
              });
              this.form.Classname =
                superclass + "——" + res.data.data.info.Classname;
              this.$forceUpdate();
              // console.log(this.form.Classname)
              // this.$set(
              //   this.form,
              //   "Classname",
              //   superclass + "——" + res.data.data.info.Classname
              // );
              console.log(this.form.Classname);
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    getOptions() {
      var that = this;
      that.$axios
        .post("classification/info?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.options = res.data.data.top_menu;
            console.log(this.options);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    test() {
      // 验证信息
      if (
        this.form.Realname == "" ||
        this.form.Pwd1 == "" ||
        this.form.Pwd == "" ||
        this.form.Phone == ""
      ) {
        this.$message({
          message: "请输入完整信息",
          type: "warning",
        });
        return false;
      }
      if (this.form.Pwd != this.form.Pwd1) {
        this.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return false;
      }
      if (!this.tests("手机", this.form.Phone)) {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    addinfo() {
      var that = this;
      // this.form.Pwd1 = this.form.Pwd;
      this.form.Company = 1; //专家公司属于省协会
      console.log(this.form);
      // console.log(that.form);
      // console.log(that.value1);
      if (!this.test()) {
        return;
      }

      this.$confirm("确认添加?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "user/add?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify(this.form)
            )
            .then((res) => {
              if (res.data.code == 10000) {
                // console.log(res.data.data);
                for (var key in this.form) {
                  if (key != "Type" && key != "Status") {
                    this.form[key] = "";
                  }
                }
                if (res.data.data) {
                  if (that.value1.length > 0) {
                    that.msdis(res.data.data);
                  } else {
                    that.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                  }
                  that.getinfo();
                  that.Popups(0);
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
                // that.$message({
                //   message: res.data.msg,
                //   type: "success"
                // });
                //    that.getinfo();
                //   this.Popups(0);
                //
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getinfo(a) {
      if (a == 1) {
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post(
          "user/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            realname: this.selname,
            status: that.selstatus,
            Type: 2,
            page: this.Page1,
            num: this.PageSize1,
          })
        )
        .then((res) => {
          console.log(that.selstatus);
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.tableData = res.data.data.list;

            // var str = "";
            // this.tableData.ExpertGroup[0].forEach(val => {
            //   str += val + ",";
            // });
            // this.tableData.ExpertGroup = str;
            this.total = res.data.data.total_num;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    Del(e) {
      var that = this;
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "user/del?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({ ID: e.ID })
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: "删除成功",
                  type: "success",
                });
                that.getinfo();
                that.Popups(0);
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    msdis(id) {
      let that = this;
      let arr = "";
      that.value1.forEach((val) => {
        arr += val + ",";
      });
      arr = arr.substr(0, arr.length - 1);
      that.$axios
        .post(
          "expertgrouprelations/save_someone?",
          that.$qs.stringify({
            token: sessionStorage.getItem("token"),
            GroupIDS: arr,
            UserID: id,
          })
        )
        .then((res1) => {
          if (res1.data.code == 10000) {
            that.$message({
              message: res1.data.msg,
              type: "success",
            });
            that.getinfo();
            that.Popups(0);
          } else {
            that.$message({
              message: res1.data.msg,
              type: "warning",
            });
          }
        });
    },
    setInfo() {
      var that = this;
      // if (!this.test()) {
      //   return;
      // }
      this.$confirm("确认修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "user/update?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify(this.form)
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                if (that.value1.length < 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  that.getinfo();
                  that.Popups(0);
                } else {
                  that.msdis(this.form.ID);
                }
                that.value1 = [];
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    submitTime() {
      console.log(this.time);
      this.$axios
        .post(
          "log/ReviewDate_edit?",
          this.$qs.stringify({
            token: sessionStorage.getItem("token"),
            start_date: this.time ? this.time[0] : "",
            end_date: this.time ? this.time[1] : "",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
  components: {
    Head,
    Foot,
    Nav,
  },
};
</script>
<style lang="less">
#Expert {
  .el-dialog__title {
    font-weight: 400;
    font-size: 0.2rem;
  }
}

.el-dialog__header {
  text-align: center;
}

.el-input__inner {
  height: 0.4rem;
}

.check2 {
  .el-checkbox__input {
    vertical-align: top;
  }
}
</style>
<style lang="less" scoped>
.tb-edit textarea {
  display: none;
}

.cell textarea {
  min-height: 1.5rem;
  width: 100%;
  resize: none;
}

.tb-edit .current-row .textarea {
  display: block;
}

.tb-edit .current-row textarea + span {
  display: none;
}

.icon {
  display: inline-block;
  height: 0.3rem;
  width: 0.3rem;
  background: url("../../assets/back/standard.png") center center no-repeat;
  position: absolute;
  left: 6.3rem;
}

.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

input,
textarea {
  border: 1px #bbbbbb solid;
}

.btn {
  width: 4.6rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
  border-radius: 0.06rem;
}

.btnchange {
  background-color: #f2f2f4;
  color: #000000;
}

.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}

.hotspot {
  .t_main {
    .show {
      color: #666;
      margin-top: 1rem;
      font-size: 0.18rem;
    }

    .checkbox-table {
      position: relative;
      margin-bottom: 0.3rem;

      // padding: 0.15rem;
      .checkbox-table_title {
        div {
          display: inline-block;
          // width: 3rem;
          height: 0.5rem;
        }
      }

      p.table {
        color: #999;
      }

      .table {
        width: 90%;
        display: flex;
        flex-wrap: wrap;

        .line-check {
          // display: inline-block;
          // margin-left: 20px;
          margin-bottom: 20px;
          width: 220px;
        }
      }

      .operation {
        width: 18%;
        position: absolute;
        right: 0.2rem;
        top: 0.3rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;

        .btn {
          // width: 0.85rem;
          width: 45%;
          height: 0.3rem;
          line-height: 0.3rem;
          font-size: 0.15rem;
          color: #fff;
          background: #2d65d2;
          text-align: center;
          border-radius: 0.04rem;
          cursor: pointer;
          margin-left: 0.1rem;
        }

        .del {
          background: #fd183e;
          // margin-top: 0.1rem;
        }

        .add {
          margin: 0.1rem 0;
        }

        .delG {
          background: #f76423;
          width: 100%;
        }
      }
    }

    .checkbox-table:hover {
      border: 1px solid lightblue;
    }
  }

  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    .title1 {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .btnselect {
      display: flex;
    }

    .switch {
      display: flex;
      width: 100%;
      // justify-content: space-between;
      align-items: center;
      margin-bottom: 0.1rem;

      p,
      span {
        margin-right: 0.1rem;
      }
    }

    .H-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.5rem;

      .btns {
        display: flex;
        width: 28%;
        justify-content: space-between;
      }

      .t-left {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 0.5rem;
        // width: 40%;

        > input,
        > div,
        select {
          margin-right: 0.2rem;
        }

        input,
        select {
          height: 0.4rem;
          padding: 0.05rem;
          width: 2rem;
        }
      }
    }
  }
}

// .Popup {
//   width: 100%;
//   position: absolute;
//   top: 0;
//   height: 100%;
//   background: rgba(0, 0, 0, 0.6);
//   z-index: 1000;

.none {
  width: 100%;
  height: 100%;
  position: relative;
}

.a_forms {
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  // width: 11.11rem;
  // min-height: 6.5rem;
  // background: white;
  // font-size: 0.16rem;

  .f-top {
    height: 0.5rem;
    width: 100%;
    text-align: center;
    line-height: 0.5rem;
    position: relative;
    border-bottom: 1px #cfcfcf solid;

    div {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      height: 0.5rem;
      width: 0.5rem;
      background: url("../../assets/back/x.png") center center no-repeat;
    }
  }

  .f-info {
    padding: 0.3rem 0.54rem 0;
    display: flex;

    .f-info-left {
      width: 1.51rem;

      img {
        width: 100%;
        height: 1.9rem;
      }

      .up {
        color: #fff;
        height: 0.25rem;
        background: #2d65d2;
        display: flex;
        margin-bottom: 0.2rem;
        justify-items: center;
        align-items: center;
        cursor: pointer;

        i {
          display: inline-block;
          width: 0.2rem;
          height: 0.2rem;
          margin-left: 0.2rem;
          margin-right: 0.1rem;
          background-image: url("../../assets/back/yun.png");
          background-position: center center;
          background-size: 100%;
        }
      }
    }

    .f-title {
      position: relative;
      overflow: hidden;
      // left: right ;
      display: flex;
      // padding-bottom: 0.5rem;
      margin-left: 0.2rem;

      .f-left {
        overflow: hidden;
        position: relative;

        > img {
          margin-left: 1.2rem;
        }

        > div {
          margin: 0.3rem 0.1rem;

          > span {
            width: 60px; //0.8rem;
            text-align: justify;
            text-align-last: justify;
            //float: left;
            //text-justify:inter-ideograph;
            color: #505050;
            display: inline-block;
            vertical-align: top;
            line-height: 0.3rem;
          }

          > a {
            color: #505050;
            font-style: normal;
            line-height: 0.3rem;
            vertical-align: top;
          }

          input,
          select,
          textarea {
            margin: 0 0.1rem 0;
            padding: 0.05rem;
          }

          textarea {
            width: 2.5rem;
          }

          > em {
            margin-left: 0.3rem;
            color: #272727;
            font-style: normal;
            vertical-align: top;
          }

          > i {
            font-style: normal;
            vertical-align: top;
            color: #ff0d0d;
            line-height: 0.3rem;
          }
        }
      }

      // .f-right {
      //    // float: right;
      //   // .block {
      //   //   height: 0.4rem;
      //   //   width: 2rem;
      //   // }
      //   // position: absolute;
      //   // top: 0;
      //   // right: 0;
      //   // width: 50%;
      // }
    }
  }

  .f-bottom {
    > span {
      width: 0.8rem;
      text-align: justify;
      text-align-last: justify;
      //float: left;
      //text-justify:inter-ideograph;
      color: #505050;
      display: inline-block;
      vertical-align: top;
      line-height: 0.3rem;
    }

    margin-left: 2.3rem;

    > textarea {
      margin-left: 0.2rem;
      margin-bottom: 0.2rem;
      width: 5.8rem;
      resize: none;
      // min-height: .6rem;
      margin-top: 0.05rem;
      height: 1.6rem;
    }

    // position: absolute;
    // top: 4.8rem;
    // left: 2rem;

    // display: flex;
    // justify-content: space-around;
    // align-items: center;
  }
}

// }
</style>
